import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ReactComponent as Close } from 'assets/images/icon-close.svg';
import classNames from 'classnames';

function NotificationModal({ orderSetup }) {
  const {
    isNotificationOn,
    notificationImage,
    notificationTitle,
    notificationMessage,
    notificationButtonText,
  } = orderSetup || {};
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isNotificationOn && notificationMessage) {
      setShowModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotificationOn, notificationMessage]);

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal ? (
        <div className='global-modal-wrapper global-modal-wrapper--active'>
          <div className='global-modal notification-modal'>
            <Close className='global-modal__close' onClick={closeModal} />

            <div
              className={classNames('global-modal__header', {
                'notification-modal__header': !notificationTitle,
              })}
            >
              {notificationTitle && (
                <h3 className='global-modal__title'>{notificationTitle}</h3>
              )}
            </div>
            <div className='global-modal__body'>
              {!notificationImage && (
                <div className='global-modal__desc notification-modal__desc scroll-shadow'>
                  <p>{notificationMessage}</p>
                </div>
              )}
              {!!notificationImage && (
                <div className='notification-img-wrapper'>
                  {isLoading && (
                    <div className='notification-img-loader global-modal__desc'>
                      <p>Loading...</p>
                    </div>
                  )}
                  <img
                    src={notificationImage}
                    alt='notification'
                    className='notification-img'
                    onLoad={() => {
                      setIsLoading(false);
                    }}
                  />
                </div>
              )}
            </div>

            {notificationButtonText && (
              <div className='global-modal__footer'>
                <div className='global-modal__actions-group'>
                  <button
                    className='global-modal-btn'
                    title={notificationButtonText}
                    type='button'
                    onClick={closeModal}
                  >
                    {notificationButtonText}
                  </button>
                </div>
              </div>
            )}
          </div>
          <div
            className='global-modal-wrapper__overlay'
            onClick={(e) => {
              e.persist();
              closeModal();
            }}
          ></div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

function mapStateToProps(state) {
  const {
    homeReducer: { orderSetup },
  } = state;

  return {
    orderSetup,
  };
}

export default connect(mapStateToProps, null)(NotificationModal);
